import * as React from 'react'
import { useAppSelector } from '../../../../reducers'

interface CountryOption {
    key: string;
    value: string;
}

interface UseDisplayCountriesProps {
    currentValues: string[];
    partialSearch?: string;
}

export default function useDisplayCountries({ currentValues, partialSearch = '' }: UseDisplayCountriesProps): CountryOption[] {
    const countries = useAppSelector<{ value: string; name: string; }[]>(state => state.countries.countries)

    return React.useMemo(() => {
        const lowerSearch = partialSearch.toLowerCase()

        return countries.filter(country => {
            const alreadyIncluded = currentValues.includes(country.value)
            const matchesPartialSearch = country.value.toLowerCase().includes(lowerSearch)
                || country.name.toLowerCase().includes(lowerSearch)

            return !alreadyIncluded && matchesPartialSearch
        }).sort((a, b) => {
            return a.name.localeCompare(b.name)
        }).map((country) => ({
            key: country.value,
            value: `${country.value} ${country.name}`,
        }))
    }, [countries, currentValues, partialSearch])
}
